import Chatbot from './Chatbot';
//import Home from './Home';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Chatbot/>
      </header>
    </div>
  );
}

export default App;
